import {Subscription} from "rxjs"

export const closeSubscription = (subscription: Empty<Subscription>): void => {
    if(subscription && !subscription.closed) {
        subscription.unsubscribe()
    }
}
